import { FC, useState } from "react";
import Container from "react-bootstrap/Container";
import { Navigate } from "react-router-dom";
import { NavigationScreen } from "app/component/screen/NavigationScreen";
import { TestTypePrerequisite } from "app/api/graph/types";
import { createTestTypePrerequisiteRoute, testTypePrerequisiteRoute } from "app/route/Routes";
import { CreateTestTypePrerequisiteForm } from "app/component/test-type-prerequisite/CreateTestTypePrerequisiteForm";
import { RouteBreadcrumbs } from "app/route/RouteBreadcrumbs";

export const CreateTestTypePrerequisiteScreen: FC = () => {
    const [testTypePrerequisite, setTestTypePrerequisite] = useState<Pick<TestTypePrerequisite, "_id"> | undefined>(
        undefined,
    );

    return testTypePrerequisite ? (
        <Navigate to={testTypePrerequisiteRoute.build({ testTypePrerequisiteId: testTypePrerequisite._id })} />
    ) : (
        <NavigationScreen>
            <Container>
                <RouteBreadcrumbs route={createTestTypePrerequisiteRoute} />
                <CreateTestTypePrerequisiteForm onCreate={setTestTypePrerequisite} />
            </Container>
        </NavigationScreen>
    );
};
